import { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import AdminSubnav from './AdminSubnav'

interface AdminLayoutProps {
  children?: ReactNode
}

export default function AdminLayout({ children }: AdminLayoutProps) {
  return (
    <div className="max-w-[1600px] mx-auto pb-8 space-y-6">
      {/* Admin Container */}
      <div className="bg-white dark:bg-[#0d1117] rounded-xl border border-gray-200 dark:border-white/5">
        {/* Pill-style Tab Navigation */}
        <AdminSubnav />

        {/* Content */}
        <div className="p-4">
          {children || <Outlet />}
        </div>
      </div>
    </div>
  )
}
